import { render, staticRenderFns } from "./businessCardVideo.vue?vue&type=template&id=4c39ee06&scoped=true&"
import script from "./businessCardVideo.vue?vue&type=script&lang=js&"
export * from "./businessCardVideo.vue?vue&type=script&lang=js&"
import style0 from "./businessCardVideo.vue?vue&type=style&index=0&id=4c39ee06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c39ee06",
  null
  
)

export default component.exports